import { call, put, takeEvery } from 'redux-saga/effects';
import { CHANGE_USER_PROFILE_REQUEST } from '../../constants/user_profile.constants';
import { getUserProfile } from '../../../requests/user_profile_requests/get_user_profile_request';
import { clearUsersCacheRequest } from '../../../../User_create/requests/clear_users_cache';
import { changeUserProfile } from '../../../../User_list/requests/update_user_request';
import { changeUserProfileRequestSuccess, changeUserProfileRequestFailure } from '../../actions/user_profile_actions/change_user_profile.actions';
import { message_success, message_error } from '../../../../../../components/Message';
import { firstLetterUpperCaseNoDashes } from '../../../../../../shared/helpers';
import { getUserInfo } from '../../../../../App/requests/get_content_request';
import { getUserInfoSuccess } from '../../../../../App/redux/actions/user_info.actions';
import { getErrorMessage } from '../../../../../../shared/helpers';

function* changeUserProfileRequest({ params }) {
    const { key, value, _id } = params;

    try {
        const profile_changed = yield call(changeUserProfile, key, value, _id);

        if (profile_changed.result || profile_changed.result === false) {
            yield put(changeUserProfileRequestFailure(profile_changed));
            message_error(profile_changed.error.errmsg.includes('duplicate') ? 'This email address is already exist' : 'Operation failed');
        } else {
            const profile = yield call(getUserProfile, _id);
            key === 'login'
                ? yield put(changeUserProfileRequestSuccess({ profile_changed: profile.options[key], key }))
                : yield put(changeUserProfileRequestSuccess({ profile_changed: key === 'ref_user_group' ? profile.options[key]._id : profile.options.person[key], key }));
            const { result, options: { user_info } } = yield call(getUserInfo);
            if (result) yield put(getUserInfoSuccess(user_info));
            message_success(`User ${firstLetterUpperCaseNoDashes(key)} Is Changed!`);

            if (key === 'ref_department') {
                yield call(clearUsersCacheRequest);
            }
        }
    } catch (error) {
        message_error(getErrorMessage(error));
    }
}

export default function* updateUserSaga() {
    yield takeEvery(CHANGE_USER_PROFILE_REQUEST, changeUserProfileRequest);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/sagas/user_profile_sagas/change_user_profile.saga.js